'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var mustache = require('mustache');
var nthBitHeader = require('@narvar/nth-bit-header');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var Button = require('@narvar/nth-block-button');
var Box = require('../../../../../../../common/components/layout/Box/Box.js');
var Typography = require('../../../../../../../common/components/Typography.js');
var TextLink = require('@narvar/nth-bit-text-link');
var nthHookTheme = require('@narvar/nth-hook-theme');
var OTPProvider = require('../OTPProvider.js');
var ErrorBanner = require('../../../../../../../common/components/ErrorBanner.js');
var useTitanAnalytics = require('../../../../../../../common/providers/titan/useTitanAnalytics.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var mustache__default = /*#__PURE__*/_interopDefaultLegacy(mustache);
var Button__default = /*#__PURE__*/_interopDefaultLegacy(Button);
var TextLink__default = /*#__PURE__*/_interopDefaultLegacy(TextLink);

const OTPSendToOrderPhone = () => {
  const titan = useTitanAnalytics["default"]();
  const {
    claimsOtpDisclaimer,
    claimsOtpSendToOrderPhoneTitle,
    claimsOtpSendToOrderPhoneDescription,
    claimsOtpLast4Formatted,
    claimsOtpSendCode,
    claimsOtpSendCodeError,
    claimsOtpSendToOrderPhoneUpdateNumberAction,
    claimsOtpSendToOrderPhoneUpdateNumberPrompt
  } = nthHookTranslations.useTranslations();
  const {
    otpSendToOrderPhone,
    handleUpdateNumberNavigate,
    state: {
      otpSendLoading,
      otpSendError,
      last4Phone
    }
  } = OTPProvider.useOTP();
  const {
    linksNoneDefault: linkStyle,
    linksNoneHover: linkHoverStyle
  } = nthHookTheme.useTheme();
  const last4PhoneFormatted = mustache__default["default"].render(claimsOtpLast4Formatted ?? '', {
    last4: last4Phone
  });
  const submitDisabled = otpSendLoading;
  React.useEffect(() => {
    // Note: This effect is only called on first component render
    titan === null || titan === void 0 ? void 0 : titan.page({
      name: 'OTP Send - Order Phone'
    })
    // eslint-disable-next-line no-console
    .catch(e => console.error(e));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React__default["default"].createElement(Box["default"], {
    gap: 4
  }, otpSendError && /*#__PURE__*/React__default["default"].createElement(ErrorBanner["default"], null, claimsOtpSendCodeError), /*#__PURE__*/React__default["default"].createElement(nthBitHeader.SemibigHeader, {
    as: "h1"
  }, claimsOtpSendToOrderPhoneTitle), /*#__PURE__*/React__default["default"].createElement(Typography.BodyTextDefault, null, mustache__default["default"].render(claimsOtpSendToOrderPhoneDescription ?? '', {
    phone: last4PhoneFormatted
  })), /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
    big: true,
    disabled: submitDisabled,
    onClick: () => {
      // eslint-disable-next-line no-console
      otpSendToOrderPhone().catch(e => console.log(e));
    }
  }, claimsOtpSendCode), /*#__PURE__*/React__default["default"].createElement(Box["default"], {
    gap: 2
  }, /*#__PURE__*/React__default["default"].createElement(Typography.BodyTextDefault, null, claimsOtpSendToOrderPhoneUpdateNumberPrompt, ` `, /*#__PURE__*/React__default["default"].createElement(TextLink__default["default"], {
    onClick: handleUpdateNumberNavigate,
    linkStyle: {
      sDefault: {
        ...linkStyle,
        fontSize: 'inherit'
      },
      sHover: {
        ...linkHoverStyle,
        fontSize: 'inherit'
      }
    }
  }, claimsOtpSendToOrderPhoneUpdateNumberAction))), /*#__PURE__*/React__default["default"].createElement(Typography.CaptionTextDefault, null, claimsOtpDisclaimer));
};
var OTPSendToOrderPhone$1 = nthHookTranslations.withTranslationsProvider(nthHookTheme.withThemeProvider(OTPSendToOrderPhone, {
  themeTokens: ['linksNoneDefault', 'linksNoneHover']
}), {
  translationKeys: ['claimsOtpDisclaimer', 'claimsOtpLast4Formatted', 'claimsOtpSendToOrderPhoneTitle', 'claimsOtpSendToOrderPhoneDescription', 'claimsOtpSendCode', 'claimsOtpSendCodeError', 'claimsOtpSendToOrderPhoneUpdateNumberAction', 'claimsOtpSendToOrderPhoneUpdateNumberPrompt']
});

exports["default"] = OTPSendToOrderPhone$1;
